<template>
  <button class="button lottery_more_btn" @click="$emit('moreaction')">
    <img class="lottery_moreImage" src="../../assets/lottery/icon_more.png" />
    <div class="lottery_text">{{ title }}</div>
  </button>
</template>

<script lang="ts">
import { Vue, Options } from "vue-class-component";
@Options({
  props: {
    title: String
  },
  emits: {
    moreaction: () => {
      return true;
    }
  }
})
export default class LotteryMore extends Vue {}
</script>

<style scoped lang="less">
@import "../../style/BaseStyle.less";
.lottery_more_btn {
  // background-color: transparent;
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
  height: 30px;
  text-align: right;
  .lottery_text {
    float: right;
    margin-left: 10px;
    margin-right: 8px;
  }
  .lottery_moreImage {
    text-align: center;
    float: right;
    padding-top: 2px;
    margin-right: 20px;
    height: 16px;
    width: 16px;
  }
}
</style>
